/**
 * Local-only dev helpers for simulating accounts and geo location on the
 * consumer site. Never bundle behind a real production flag — the panel that
 * uses these is mounted only when `import.meta.env.DEV`.
 */
const GEO_STORAGE_KEY = 'fetmode.dev.geo-override';
function hasWindow() {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}
export function readDevGeoOverride() {
    if (!hasWindow()) {
        return null;
    }
    const raw = window.localStorage.getItem(GEO_STORAGE_KEY);
    if (!raw) {
        return null;
    }
    try {
        const parsed = JSON.parse(raw);
        if (typeof parsed.countryCode !== 'string' || parsed.countryCode.length < 2) {
            return null;
        }
        return {
            countryCode: parsed.countryCode.toUpperCase(),
            subdivisionCode: parsed.subdivisionCode?.toUpperCase(),
            label: parsed.label,
        };
    }
    catch {
        window.localStorage.removeItem(GEO_STORAGE_KEY);
        return null;
    }
}
export function writeDevGeoOverride(override) {
    if (!hasWindow()) {
        return;
    }
    window.localStorage.setItem(GEO_STORAGE_KEY, JSON.stringify(override));
}
export function clearDevGeoOverride() {
    if (!hasWindow()) {
        return;
    }
    window.localStorage.removeItem(GEO_STORAGE_KEY);
}
/**
 * Headers understood by the API's `resolveRegionFromRequest` for geo
 * simulation. Returns undefined when no override is set so real edge headers
 * win. Note: a server-side `GEO_DEV_COUNTRY` env still takes priority.
 */
export function devRequestHeaders() {
    const override = readDevGeoOverride();
    if (!override) {
        return undefined;
    }
    const headers = { 'x-fm-country': override.countryCode };
    if (override.subdivisionCode) {
        headers['x-fm-region'] = override.subdivisionCode;
    }
    return headers;
}
//# sourceMappingURL=dev-settings.js.map